import OfferBar from "./OfferBar";
import "./OfferBar.css";

export default OfferBar;